<template>
  <div class="privacy-text-block">
    <div class="container-bar">
      <div class="privacy-text" v-html="contentData.data.list[0].teaser"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['contentData'],
  mounted(){
    console.log(this.contentData)
  }
};
</script>

<style lang="scss" scoped>
.privacy-text-block{
  min-height: 100vh;
}
.privacy-text{
  &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup{
    
     font-family: "FiraGO-Italic";
     will-change: transform;
   }
}
</style>
